import React from 'react'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from '../../data/store'
import { creditApplicationSelectors } from '../../data/store/CreditApplicationStore'
import { FormatCurrency } from '../utils/Formatter'

function LoanTableComponent() {
  const { t } = useTranslation()
  const computedAmounts = useAppSelector(creditApplicationSelectors.getComputedAmounts)

  return (
    <table>
      <thead>
        <tr>
          <th>{t<string>('common.loanTerm')}</th>
          <th>
            {t<string>('common.monthlyAmount')} <sup style={{ color: 'red' }}>*</sup>
          </th>
        </tr>
      </thead>
      <tbody>
        {computedAmounts &&
          computedAmounts.termAmountPair.map((loan) => (
            <tr key={loan?.term}>
              <td>{loan?.term}</td>
              <td>{FormatCurrency(loan?.amount)}</td>
            </tr>
          ))}
      </tbody>
    </table>
  )
}

export default LoanTableComponent
